import React, { memo } from 'react';
import { Button, Space } from 'antd';
import { ArrowLeftOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface SearchActionsProps {
  onBack: () => void;
  onStartOver: () => void;
  onRetry?: () => void;
  showRetry?: boolean;
  variant?: 'default' | 'error';
}

export const SearchActions: React.FC<SearchActionsProps> = memo(({ 
  onBack, 
  onStartOver, 
  onRetry,
  showRetry = false,
  variant = 'default'
}) => {
  const { t } = useTranslation();

  if (variant === 'error') {
    return (
      <Space>
        {showRetry && onRetry && (
          <Button 
            type="primary" 
            icon={<ReloadOutlined />}
            onClick={onRetry}
          >
            {t('demo.searchResults.tryAgain')}
          </Button>
        )}
        <Button onClick={onBack}>
          {t('demo.searchResults.back')}
        </Button>
      </Space>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <Button 
        size="large"
        icon={<ArrowLeftOutlined />}
        onClick={onBack}
        style={{ 
          minWidth: 120,
          height: 48,
          borderRadius: 8
        }}
      >
        {t('demo.searchResults.back')}
      </Button>

      <Button 
        size="large"
        onClick={onStartOver}
        style={{ 
          minWidth: 160,
          height: 48,
          borderRadius: 8
        }}
      >
        {t('demo.searchResults.searchAnother')}
      </Button>
    </div>
  );
});

SearchActions.displayName = 'SearchActions';